/**
 * Environment Configuration
 */

// 2026-06-23 — was `${window.location.protocol}//${window.location.hostname}:3000`
// which built e.g. `https://alphagroves.com:3000` in the browser. Port 3000
// isn't exposed externally on any env (only the docker network), so the
// SPA's watchlist / options / strategies endpoints all hit a connection-
// refused. UAT looked fine in spot tests because the LOGIN page + the few
// API paths that use relative `/api/...` URLs (auth, markets) still worked
// — the breakage only surfaced once a page actually consumed
// environment.api.watchlist / options / strategies.
//
// Fix: use a same-origin relative `/api` base, matching environment.prod.ts.
// nginx (edge + inner) proxies /api/<service> to the right backend on every
// env, so this single relative form works for dev (localhost:80), uat
// (localhost:8180), and prod (alphagroves.com via Cloudflare).
//
// Note: this file is the default Angular env. angular.json currently has
// no `production` configuration, so even prod builds use THIS file (not
// environment.prod.ts) — fixing it here covers every env until
// fileReplacements is added to the production build configuration.
const API_GATEWAY = typeof window === 'undefined' // NOSONAR S7764 — browser-only Angular code
  ? '/api'
  : `${window.location.origin}/api`; // NOSONAR S7764 — browser-only Angular code

export const environment = {
  production: false,

  // Gateway base URL (auto-detects host for external access)
  apiUrl: API_GATEWAY,

  // API Endpoints (for real implementation)
  api: {
    auth: '/api/auth',
    market: '/api/markets',
    watchlist: `${API_GATEWAY}/watchlists`,
    options: `${API_GATEWAY}/options`,
    strategies: `${API_GATEWAY}/strategies`,
  },
  
  // Feature flags - Enable/disable real implementations
  features: {
    realAuth: false,           // Real login/register
    realMarketData: false,     // Real stock quotes
    realOptionsChain: false,   // Real options data
    realGreeks: false,         // Real Greeks calculation
    realTechnicals: false,     // Real technical indicators
    realSentiment: false,      // Real sentiment analysis
    realStrategies: false,     // Real strategy recommendations
    realWebSocket: false,      // Real-time updates
  },
  
  // Logging
  logging: {
    verbose: true,            // Log every API call
    trackRequestTiming: true, // Measure response times
    exportLogs: true,         // Allow CSV export
  },

  // Sentry disabled in dev: the shared DSN rejects dev-env events (403 on the
  // ingest POST, a persistent browser-console error). main.ts skips Sentry.init
  // entirely when this is empty. Prod keeps its DSN in environment.prod.ts.
  sentryDsn: '',
  sentryEnvironment: 'development',
};
